import { createFileRoute } from '@tanstack/react-router'
import InvitePage from '../../Pages/LoginPage/InvitePage'
import ErrorComponent from '../../Components/ErrorComponent'

export const Route = createFileRoute('/_public/invite')({
    component: Wrapper,
    errorComponent: ({ error, reset }) => {
        return <ErrorComponent error={error} reset={reset} />
    },
})

function Wrapper() {
    return (
        <>
            <InvitePage {...Route.useParams()} {...Route.useSearch()} />
        </>
    )
}
